import { FC, useEffect, useState } from 'react';
import { trimString } from 'utils';
import classNames from 'classnames';
import MarkdownComponent from 'components/MarkdownComponent';

interface BotResponseDraftsProps {
    drafts: string[];
    handleDraftSelection: (draft: string) => void;
}

const DraftToggle = ({ isViewDrafts, setIsViewDrafts }) => (
    <div className="draft-toggle" onClick={() => setIsViewDrafts((prev) => !prev)}>
        <p>View other drafts</p>
        <i className={`fal fa-chevron-${isViewDrafts ? 'up' : 'down'}`} />
    </div>
);

const DraftContainer = ({
    draftId,
    draft,
    hoveredAnswer,
    clickedAnswer,
    setHoveredAnswer,
    setClickedAnswer,
    handleDraftSelection
}) => {
    const isHighlighted = draftId === hoveredAnswer;
    const isSelected = draftId === clickedAnswer;

    const handleMouseEnter = () => setHoveredAnswer(draftId);
    const handleMouseLeave = () => setHoveredAnswer(null);
    const handleClick = () => handleDraftSelection(draft);

    return (
        <div
            className={classNames('draft-container', { highlight: isHighlighted, selected: isSelected })}
            onMouseDown={() => setClickedAnswer(draftId)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}>
            <div className={classNames('draft-title', { highlight: isHighlighted, selected: isSelected })}>
                <p>Draft {draftId + 1}</p>
            </div>
            <MarkdownComponent>{trimString(draft, 40)}</MarkdownComponent>
        </div>
    );
};

const BotResponseDrafts: FC<BotResponseDraftsProps> = ({ drafts }) => {
    const [hoveredAnswer, setHoveredAnswer] = useState(0);
    const [clickedAnswer, setClickedAnswer] = useState(0);
    const [showDrafts, setShowDrafts] = useState(false);
    const [selectedDraft, setSelectedDraft] = useState<string>(drafts && drafts[0]);

    useEffect(() => setSelectedDraft(drafts && drafts[0]), [drafts]);
    const hasMultpleDrafts = drafts?.length > 1;

    if (!hasMultpleDrafts) {
        return (
            <div className="source-container-bot">
                <MarkdownComponent>{selectedDraft}</MarkdownComponent>
            </div>
        );
    }

    return (
        hasMultpleDrafts && (
            <div className="source-container-bot">
                <MarkdownComponent>{selectedDraft}</MarkdownComponent>
                <DraftToggle isViewDrafts={showDrafts} setIsViewDrafts={setShowDrafts} />
                <div className={classNames('main-draft-container', { show: showDrafts })}>
                    {showDrafts &&
                        drafts?.map((draft: string, draftId: number) => (
                            <DraftContainer
                                draftId={draftId}
                                draft={draft}
                                hoveredAnswer={hoveredAnswer}
                                clickedAnswer={clickedAnswer}
                                setHoveredAnswer={setHoveredAnswer}
                                setClickedAnswer={setClickedAnswer}
                                handleDraftSelection={(selectedDraft: string) =>
                                    selectedDraft && setSelectedDraft(selectedDraft)
                                }
                            />
                        ))}
                </div>
            </div>
        )
    );
};

export default BotResponseDrafts;
